<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>

<div class="container pt-5">
  <div class="d-flex flex-row bd-highlight">
    <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">

      <div class="card my-3"  *ngFor="let tourpackageDoc of tourpackageCol | async">
        <div class="list-group my-1 card-header">
          <a class="list-group-item list-group-flush border-0 bg-light">                
            <div class="media">                        
              <img [src]="tourpackageDoc.ownerProfilePictureUrl" class="mr-3 align-self-center rounded-circle image" alt="...">
              <div class="media-body">
                <p class="h5">{{tourpackageDoc.ownerName}}</p>
                <small class="text-muted font-italic">{{tourpackageDoc.dateCreated | date}}</small>
              </div>
            </div>               
          </a>   
        </div>
        <img [src]="tourpackageDoc.pictureUrl" class="card-img-top">
        <div class="card-body">
          <span class="h5">{{tourpackageDoc.name}}</span>

          <ul class="list-group list-group-flush">
            <li class="list-group-item h5">
            </li>
            <li class="list-group-item">
              {{tourpackageDoc.price | currency:'K'}}
            </li>
            <li class="list-group-item">
              {{tourpackageDoc.duration}} <span *ngIf="tourpackageDoc.duration <= 1">day</span> <span *ngIf="tourpackageDoc.duration > 1">days</span>
            </li>
            <li class="list-group-item">
              {{tourpackageDoc.location}}
            </li>
          </ul>
        </div>
        <a (click)="routeTourPackageDetailPage(tourpackageDoc.id)" routerLink="" class="btn btn-dark text-white btn-block my-1 stretched-link">View Details...</a>
      </div>  
    </div>
  </div>
</div>
